import { DividendPerYear } from "@api";

interface Kpis {
  latestYear: number;
  latestValue: number;
  latestYearlyChange: number | null;
  count: number;
  average: number;
  sum: number;
}

export const computeDividendKpis = (
  dividends?: DividendPerYear[]
): Kpis | null => {
  if (!dividends?.length) return null;

  const sorted = [...dividends].sort((a, b) => a.year - b.year);
  const actuals = sorted.filter((d) => !d.isEstimate);
  const latest = actuals.at(-1) ?? sorted.at(-1)!;
  const latestIndex = sorted.indexOf(latest);
  const previous = latestIndex > 0 ? sorted[latestIndex - 1] : undefined;

  const latestYearlyChange =
    previous && previous.totalDividendPerShare !== 0
      ? (latest.totalDividendPerShare - previous.totalDividendPerShare) /
        previous.totalDividendPerShare
      : null;

  const sum = actuals.reduce((acc, d) => acc + d.totalDividendPerShare, 0);
  const average = actuals.length > 0 ? sum / actuals.length : 0;

  return {
    latestYear: latest.year,
    latestValue: latest.totalDividendPerShare,
    latestYearlyChange,
    count: actuals.length,
    average,
    sum,
  };
};

export const buildDividendChartData = (
  dividends: DividendPerYear[] | undefined,
  solidColor: string,
  estimateColor: string
) => {
  if (!dividends?.length) return { categories: [], data: [] };
  const sorted = [...dividends].sort((a, b) => a.year - b.year);
  return {
    categories: sorted.map((d) => `${d.year}${d.isEstimate ? "(e)" : ""}`),
    data: sorted.map((d) => ({
      y: d.totalDividendPerShare,
      color: d.isEstimate ? estimateColor : solidColor,
    })),
  };
};
